<template>
    <!-- @keyup="keyup" -->
    <div
        id="app"
        tabindex="-1"
        :class="{
            night: grimoire.isNight,
            static: grimoire.isStatic
        }"
        :style="{
            backgroundImage: grimoire.background ? `url('${grimoire.background}')` : ''
        }"
    >
        <video
            id="background"
            v-if="grimoire.background && grimoire.background.match(/\.(mp4|webm)$/i)"
            :src="grimoire.background"
            autoplay
            loop
        ></video>
        <div class="backdrop"></div>
        <transition name="blur">
            <Intro v-if="!players.length"></Intro>
            <TownInfo v-if="players.length && !session.nomination"></TownInfo>
            <Vote v-if="session.nomination"></Vote>
        </transition>
        <TownSquare></TownSquare>
        <Menu ref="menu"></Menu>
        <EditionModal />
        <FabledModal />
        <RolesModal />
        <ReferenceModal />
        <NightOrderModal />
        <VoteHistoryModal />
        <GameStateModal />
        <Gradients />
        <GeneratePoster />
        <UpdateLog />
        <GsLogin />
        <Talk />

        <!-- <span id="version">v{{ version }}</span> -->
        <span id="version"
            ><a href="https://beian.miit.gov.cn/#/Integrated/index" target="_blank">冀ICP备05003890号-1</a>
            冀ICP证B2-20130083</span
        >

        <vue-draggable-resizable class-name="draggable-resizable" w="auto" h="auto">
            <div class="countDown">
                <div class="countDownTitle">公聊倒计时</div>
                <div class="countDownBox">
                    <div class="countAdjust">
                        <font-awesome-icon
                            icon="chevron-up"
                            @click="(CountDownTime = CountDownTime + 1 * 60), (countBackUp = countBackUp + 1 * 60)"
                        />
                        <font-awesome-icon
                            icon="chevron-down"
                            @click="
                                (CountDownTime = CountDownTime > 0 ? CountDownTime - 1 * 60 : 0),
                                    (countBackUp = countBackUp > 0 ? countBackUp - 1 * 60 : 0)
                            "
                        />
                    </div>
                    <count-down
                        class="countDdwnBox"
                        :time="CountDownTime"
                        :isStart="isStart"
                        format="mm<b>:</b>ss"
                        @end="countDownEnd"
                        ref="countdown"
                    ></count-down>
                    <a
                        href="javascript:;"
                        :style="{ background: isStart > 0 ? '#1e5ad7' : '#e53c3c' }"
                        @click="toggleCountDown()"
                        >{{ isStart ? "重置" : "开始" }}</a
                    >
                </div>
            </div>
        </vue-draggable-resizable>
    </div>
</template>

<script>
import { mapMutations, mapState } from "vuex";
import { version } from "../package.json";
import TownSquare from "./components/TownSquare";
import TownInfo from "./components/TownInfo";
import Menu from "./components/Menu";
import RolesModal from "./components/modals/RolesModal";
import EditionModal from "./components/modals/EditionModal";
import Intro from "./components/Intro";
import ReferenceModal from "./components/modals/ReferenceModal";
import Vote from "./components/Vote";
import Gradients from "./components/Gradients";
import NightOrderModal from "./components/modals/NightOrderModal";
import FabledModal from "@/components/modals/FabledModal";
import VoteHistoryModal from "@/components/modals/VoteHistoryModal";
import GameStateModal from "@/components/modals/GameStateModal";
import GeneratePoster from "@/components/modals/GeneratePoster";
import UpdateLog from "@/components/modals/UpdateLog";

import GsLogin from "./components/GsLogin";

import CountDown from "./components/countDown.vue";
import Talk from "./components/Talk.vue";

import VueDraggableResizable from "vue-draggable-resizable";

export default {
    components: {
        GameStateModal,
        VoteHistoryModal,
        FabledModal,
        NightOrderModal,
        Vote,
        ReferenceModal,
        Intro,
        TownInfo,
        TownSquare,
        Menu,
        EditionModal,
        RolesModal,
        Gradients,
        CountDown,
        VueDraggableResizable,
        GeneratePoster,
        UpdateLog,
        GsLogin,
        Talk
    },
    computed: {
        ...mapState(["grimoire", "session"]),
        ...mapState("players", ["players"])
    },
    data() {
        return {
            version,
            CountDownTime: 10 * 60,
            countBackUp: 10 * 60,
            isStart: false,

            width: 0,
            height: 0,
            x: 0,
            y: 0
        };
    },
    mounted() {
        if (this.$utils.cookie("UserCookie")) {
            if (!this.session.isSpectator) {
                this.$store.commit(
                    "session/setSessionUserInfo",
                    JSON.parse(decodeURIComponent(this.$utils.cookie("UserCookie")))
                );
            } else {
                this.$store.commit(
                    "session/setPlayerUserInfo",
                    JSON.parse(decodeURIComponent(this.$utils.cookie("UserCookie")))
                );
            }
            this.LoginUser(2);
        } else {
            this.$utils.logincheck().then(() => {
                if (!this.session.isSpectator) {
                    this.$store.commit(
                        "session/setSessionUserInfo",
                        JSON.parse(decodeURIComponent(this.$utils.cookie("UserCookie")))
                    );
                } else {
                    this.$store.commit(
                        "session/setPlayerUserInfo",
                        JSON.parse(decodeURIComponent(this.$utils.cookie("UserCookie")))
                    );
                }
                this.LoginUser(2);
            }).catch(() => {
                console.log("没有登录");
                this.$store.commit("session/setSpectator", false);
                this.$store.commit("session/setSessionId", "");
                if (this.session.nomination) {
                    this.$store.commit("session/nomination");
                }
                this.$store.commit("players/clear");
                // this.toggleModal("loginBox");
            });
        }
        window.addEventListener("keyup", this.keyup, false);

        if (!this.$utils.browser.isWeiXin()) {
            if (this.$utils.browser.IsMobile()) {
                if (location.href.indexOf("app.gamersky") >= 0) {
                    this.$utils
                        .AjaxJsonp("//click.gamersky.com/Common/GetHits.aspx", {
                            id: 1475400,
                            script: 3
                        })
                        .then(response => {});
                } else {
                    this.$utils
                        .AjaxJsonp("//click.gamersky.com/Common/GetHits.aspx", {
                            id: 1475403,
                            script: 3
                        })
                        .then(response => {});
                }
            } else {
                if (location.href.indexOf("app.gamersky") >= 0) {
                    this.$utils
                        .AjaxJsonp("//click.gamersky.com/Common/GetHits.aspx", {
                            id: 1475399,
                            script: 3
                        })
                        .then(response => {});
                } else {
                    this.$utils
                        .AjaxJsonp("//click.gamersky.com/Common/GetHits.aspx", {
                            id: 1475402,
                            script: 3
                        })
                        .then(response => {});
                }
            }
        }

        window.addEventListener("beforeunload", function(event) {
            event.returnValue = "离开页面将导致数据丢失！";
        });
    },
    methods: {
        onResize: function(x, y, width, height) {
            this.x = x;
            this.y = y;
            this.width = width;
            this.height = height;
        },
        onDrag: function(x, y) {
            this.x = x;
            this.y = y;
        },

        countDownEnd() {
            console.log("倒计时结束");
            // this.CountDownTime = 20;
        },
        keyup({ key, ctrlKey, metaKey }) {
            if(!this.$utils.cookie("UserCookie")) return;
            if(this.grimoire.isFocus) return;
            if (ctrlKey || metaKey) return;
            if (document.querySelector(".gs-alert-wrapper")) return;
            switch (key.toLocaleLowerCase()) {
                case "g":
                    this.$store.commit("toggleGrimoire");
                    break;
                case "a":
                    this.$refs.menu.addPlayer();
                    break;
                case "h":
                    this.$refs.menu.hostSession();
                    break;
                case "j":
                    this.$refs.menu.joinSession();
                    break;
                case "r":
                    this.$store.commit("toggleModal", "reference");
                    break;
                case "n":
                    this.$store.commit("toggleModal", "nightOrder");
                    break;
                case "e":
                    if (this.session.isSpectator) return;
                    this.$store.commit("toggleModal", "edition");
                    break;
                case "c":
                    if (this.session.isSpectator) return;
                    this.$store.commit("toggleModal", "roles");
                    break;
                case "v":
                    if (this.session.voteHistory.length || !this.session.isSpectator) {
                        this.$store.commit("toggleModal", "voteHistory");
                    }
                    break;
                case "s":
                    if (this.session.isSpectator) return;
                    this.$refs.menu.toggleNight();
                    break;
                case "escape":
                    this.$store.commit("toggleModal");
            }
        },
        toggleCountDown() {
            this.isStart = !this.isStart;
            if (this.isStart) {
                this.$refs.countdown.refreshCount();
                this.$utils
                    .AjaxJsonp("//click.gamersky.com/Common/GetHits.aspx", {
                        id: 1478658,
                        script: 3
                    })
                    .then(response => {});
            }
        },
        // 登录埋点
        LoginUser(LoginType) {
            this.$ajax
                .get("//clocktowerevent.gamersky.com/ClockTowerEventStatistics/AddLoginUser?LoginType=" + LoginType, {})
                .then(response => {
                    if (response.error == "") {
                    }
                });
        },
        ...mapMutations(["toggleModal"])
    }
};
</script>

<style lang="scss">
@import "vars";

@font-face {
    font-family: "Papyrus";
    src: url("assets/fonts/papyrus.eot"); /* IE9*/
    src: url("assets/fonts/papyrus.eot?#iefix") format("embedded-opentype"),
        /* IE6-IE8 */ url("assets/fonts/papyrus.woff2") format("woff2"),
        /* chrome firefox */ url("assets/fonts/papyrus.woff") format("woff"),
        /* chrome firefox */ url("assets/fonts/papyrus.ttf") format("truetype"),
        /* chrome firefox opera Safari, Android, iOS 4.2+*/ url("assets/fonts/papyrus.svg#PapyrusW01") format("svg"); /* iOS 4.1- */
}

@font-face {
    font-family: PiratesBay;
    src: url("assets/fonts/piratesbay.ttf");
    font-display: swap;
}

html,
body {
    font-size: 1.2em;
    line-height: 1.4;
    background: url("assets/background.jpg") center center;
    background-size: cover;
    color: white;
    height: 100%;
    font-family: "Roboto Condensed", sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    padding: 0;
    margin: 0;
    overflow: hidden;
}

@import "media";

* {
    box-sizing: border-box;
    position: relative;
}

a {
    color: $townsfolk;
    &:hover {
        color: $demon;
    }
}

h1,
h2,
h3,
h4,
h5 {
    margin: 0;
    text-align: center;
    font-family: PiratesBay, sans-serif;
    letter-spacing: 1px;
    font-weight: normal;
}

ul {
    list-style-type: none;
    margin: 0;
    padding: 0;
}

#app {
    height: 100%;
    background-position: center center;
    background-size: cover;
    display: flex;
    align-items: center;
    align-content: center;
    justify-content: center;

    // disable all animations
    &.static *,
    &.static *:after,
    &.static *:before {
        transition: none !important;
        animation: none !important;
    }
}

#version {
    position: absolute;
    text-align: right;
    left: 50%;
    transform: translateX(-50%);
    bottom: 10px;
    font-size: 60%;
    opacity: 0.5;
    a {
        color: #fff;
    }
}

.blur-enter-active,
.blur-leave-active {
    transition: all 250ms;
    filter: blur(0);
}
.blur-enter,
.blur-leave-to {
    opacity: 0;
    filter: blur(20px);
}

// Buttons
.button-group {
    display: flex;
    align-items: center;
    justify-content: center;
    align-content: center;
    .button {
        margin: 5px 0;
        border-radius: 0;
        &:first-child {
            border-top-left-radius: 15px;
            border-bottom-left-radius: 15px;
        }
        &:last-child {
            border-top-right-radius: 15px;
            border-bottom-right-radius: 15px;
        }
    }
}
.button {
    padding: 0;
    border: solid 0.125em transparent;
    border-radius: 15px;
    box-shadow: inset 0 1px 1px #9c9c9c, 0 0 10px #000;
    background: radial-gradient(at 0 -15%, rgba(#fff, 0.07) 70%, rgba(#fff, 0) 71%) 0 0/ 80% 90% no-repeat content-box,
        linear-gradient(#4e4e4e, #040404) content-box, linear-gradient(#292929, #010101) border-box;
    color: white;
    font-weight: bold;
    text-shadow: 1px 1px rgba(0, 0, 0, 0.5);
    line-height: 170%;
    margin: 5px auto;
    cursor: pointer;
    transition: all 200ms;
    white-space: nowrap;
    &:hover {
        color: red;
    }
    &.disabled {
        color: gray;
        cursor: default;
        opacity: 0.75;
    }
    &:before,
    &:after {
        content: " ";
        display: inline-block;
        width: 10px;
        height: 10px;
    }
    &.townsfolk {
        background: radial-gradient(at 0 -15%, rgba(255, 255, 255, 0.07) 70%, rgba(255, 255, 255, 0) 71%) 0 0/80% 90%
                no-repeat content-box,
            linear-gradient(#0031ad, rgba(5, 0, 0, 0.22)) content-box, linear-gradient(#292929, #001142) border-box;
        box-shadow: inset 0 1px 1px #002c9c, 0 0 10px #000;
        &:hover:not(.disabled) {
            color: #008cf7;
        }
    }
    &.demon {
        background: radial-gradient(at 0 -15%, rgba(255, 255, 255, 0.07) 70%, rgba(255, 255, 255, 0) 71%) 0 0/80% 90%
                no-repeat content-box,
            linear-gradient(#ad0000, rgba(5, 0, 0, 0.22)) content-box, linear-gradient(#292929, #420000) border-box;
        box-shadow: inset 0 1px 1px #9c0000, 0 0 10px #000;
    }
}

/* video background */
video#background {
    position: absolute;
    width: 100%;
    height: 100%;
    object-fit: cover;
}

/* Night phase backdrop */
#app > .backdrop {
    position: absolute;
    left: 0;
    right: 0;
    bottom: 0;
    top: 0;
    pointer-events: none;
    background: black;
    background: linear-gradient(180deg, rgba(0, 0, 0, 1) 0%, rgba(1, 22, 46, 1) 50%, rgba(0, 39, 70, 1) 100%);
    opacity: 0;
    transition: opacity 1s ease-in-out;
    &:after {
        content: " ";
        display: block;
        width: 100%;
        padding-right: 2000px;
        height: 100%;
        background: url("assets/clouds.png") repeat;
        background-size: 2000px auto;
        animation: move-background 120s linear infinite;
        opacity: 0.3;
    }
}

@keyframes move-background {
    from {
        transform: translate3d(-2000px, 0px, 0px);
    }
    to {
        transform: translate3d(0px, 0px, 0px);
    }
}

#app.night > .backdrop {
    opacity: 0.5;
}

.draggable-resizable {
    position: fixed;
    left: 10px;
    top: 18vh;
}

.countDown {
    background: rgba($color: #000000, $alpha: 0.9);
    border: 5px solid #000;
    padding: 1vh 1vw;
    border-radius: 10px;
    width: auto;
    cursor: move;
    .countDownTitle {
        font-size: 1em;
        color: #fff;
        text-align: center;
        margin-bottom: 12px;
        line-height: 1;
    }
    .countDownBox {
        display: flex;
        align-items: center;
        .countAdjust {
            display: flex;
            flex: 1;
            flex-direction: column;
            margin-right: 10px;
            justify-content: space-between;
            height: 50px;
            svg {
                display: block;
                width: 20px;
                height: 20px;
                cursor: pointer;
            }
        }
        .countDdwnBox {
            display: flex;
            align-items: center;
            span {
                display: flex;
                justify-content: center;
                align-items: center;
                padding: 9px 13px;
                background: #fff;
                border-radius: 5px;
                font-size: 24px;
                color: #e53c3c;
                font-weight: bold;
            }
            b {
                margin: 0 9px;
            }
        }
        a {
            display: flex;
            justify-content: center;
            align-items: center;
            flex-shrink: 0;
            height: 35px;
            border-radius: 17.5px;
            padding: 0 16px;
            text-decoration: none;
            background: transparent;
            color: #fff;
            margin-left: 12px;
            transition: all 0.3s;
            outline: none;
            -webkit-tap-highlight-color: rgba(255, 255, 255, 0);
            -webkit-user-select: none;
            -moz-user-focus: none;
            -moz-user-select: none;
        }
    }
}
@media screen and (max-width: 500px) {
    .countDown {
        zoom: 0.7;
        width: auto;
        padding: 1.4vh 1vw;
        
    }
    .draggable-resizable {
        position: fixed;
        right: 10px;
        bottom: 10px;
        left: unset;
        top: unset;
        z-index: 70 !important;
    }
}
</style>
